module.exports = __webpack_public_path__ + "static/media/grass.32e1cc11.jpg";